import { CircularProgress, Typography } from "@mui/material"
import {
  OpportunityDetailLoadingWrapper,
  OpportunityDetailWrapper,
} from "./Atom"
import { useAppSelector } from "../../../redux/hooks"

const UserGroupsDetails = () => {
  const { userGroupsDetails } = useAppSelector((state: any) => state.users)

  return (
    <>
      {userGroupsDetails ? (
        <OpportunityDetailWrapper>
          <Typography fontSize={12} fontWeight={400} color={"#98B6F7"}>
            Group/Practice Name
          </Typography>
          {userGroupsDetails?.map((group: any) => (
            <Typography
              fontSize={14}
              fontWeight={500}
              color={"#FFFFFF"}
              sx={{ margin: "8px 0" }}
            >
              {group?.group_name}
            </Typography>
          ))}
          {/* <Box>
                        <Typography fontSize={10} fontWeight={400}>
                            Start Date
                        </Typography>
                        <Typography fontSize={14} fontWeight={500}>
                            {moment(metricOpportunityDetail?.start_date).format("YYYY/MM/DD")}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography fontSize={10} fontWeight={400}>
                            Set By
                        </Typography>
                        <Typography fontSize={14} fontWeight={500}>
                            {metricOpportunityDetail?.creator_name}
                        </Typography>
                    </Box> */}
        </OpportunityDetailWrapper>
      ) : (
        <OpportunityDetailLoadingWrapper>
          <CircularProgress sx={{ color: "#FFFFFF" }} />
        </OpportunityDetailLoadingWrapper>
      )}
    </>
  )
}

export default UserGroupsDetails
